export default {
  defaultSortField: 'name',
  defaultSortOrder: 'asc',
  isDetailed: false,
  stickeyHeaders: false,
  rearrangeCols: false,
  toolBar: {
    hideSearchBar: true,
    buttons: () => [],
    bulkActions: () => [],
  },
  fields: [
    {
      name: 'dayViewName',
      prop: 'name',
      width: '25ex',
      title: 'Name',
      id: 'name',
      fieldName: 'name',
      inputProps: {
        type: 'text',
      },
      visible: true,
    }, {
      name: 'field-generic-input',
      prop: 'effectiveOwner.user.name',
      fieldName: 'owner',
      width: '10ex',
      title: 'Owner',
      id: 'owner',
      inputProps: {
        type: 'owner.user',
      },
      visible: true,
    },
    {
      name: 'field-generic-input',
      prop: 'project.name',
      fieldName: 'project',
      width: '15ex',
      title: 'Project Name',
      id: 'projectName',
      inputProps: {
        type: 'text',
      },
      visible: true,
    },
    {
      name: 'field-stage',
      prop: 'stage',
      id: 'stage',
      title: 'Current Stage',
      width: '15ex',
      show: true,
      defaultVisible: true,
      iPadVisible: true,
      inputProps: {
        stageColor: true,
      },
      visible: true,
      cardProps: {
        cardType: '__t',
      },
    },
    {
      name: 'stageDate',
      prop: 'stageDate',
      width: '20ex',
      title: 'Date',
      id: 'stageDate',
      inputProps: {
        type: 'text',
      },
      visible: true,
    },
  ],
};
